<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-text class="pa-0">
            <v-container fluid>
              <v-row justify="end" align="center" class="px-4 pt-4">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="buscaAspirante"
                    color="secondary"
                    background-color="primary"
                    rounded
                    filled
                    placeholder="Buscar por nombre, CURP o CUIP..."
                    append-icon="mdi-magnify"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    class="primary"
                    :headers="headers"
                    :items="aspirantesConvertidos"
                    :search="buscaAspirante"
                    calculate-widths
                    :items-per-page="15"
                    :footer-props="{
                      'items-per-page-options': [10, 15, 25, 50, 100],
                    }"
                  >
                    <template v-slot:[`item.nombreCompleto`]="{ item }">
                      <span class="text-body-2">{{ getFullName(item) }}</span>
                    </template>
                    <template v-slot:[`item.fechaNacimiento`]="{ item }">
                      <span class="text-body-2">{{ formatDate(item.fechaNacimiento) }}</span>
                    </template>
                    <template v-slot:[`item.fechaRegistro`]="{ item }">
                      <span class="text-body-2">{{ formatDate(item.fechaRegistro) }}</span>
                    </template>
                    <template v-slot:[`item.activo`]="{ item }">
                      <v-chip small :color="item.activo ? 'success' : 'error'">
                        {{ item.activo ? 'Activo' : 'Inactivo' }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                variant="secondary"
                                icon="mdi-card-account-details-outline"
                                :to="{
                                  path: '/enlace_c3/expediente_personal/' + item.id_personal,
                                  params: { id: item.id_personal },
                                }"
                              />
                            </span>
                          </template>
                          <span>Ver expediente</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import IconButton from '@src/components/base/IconButton.vue'

export default {
  components: {
    IconButton,
  },

  data() {
    return {
      headers: [
        { text: 'Nombre completo', value: 'nombreCompleto' },
        { text: 'CURP', value: 'curp' },
        { text: 'CUIP', value: 'CUIP' },
        { text: 'RFC', value: 'rfc' },
        { text: 'Fecha nacimiento', value: 'fechaNacimiento' },
        { text: 'Fecha registro', value: 'fechaRegistro' },
        { text: 'Credencial', value: 'numeroCredencial' },
        { text: 'Estatus', value: 'activo', sortable: false },
        { text: 'Opciones', value: 'opciones', align: 'left', sortable: false },
      ],
      buscaAspirante: '',
      pageNumber: 1,
      rowsOfPage: 100,
    }
  },

  async mounted() {
    await this.fetchAspirantesConvertidosPolicias({
      pageNumber: this.pageNumber,
      rowsOfPage: this.rowsOfPage,
    })
  },

  computed: {
    ...mapGetters('aspirantes', {
      aspirantesConvertidos: 'getAspirantesConvertidosPolicias',
    }),
  },

  methods: {
    ...mapActions('aspirantes', ['fetchAspirantesConvertidosPolicias']),

    getFullName(aspirante) {
      return [
        aspirante.nombre?.trim(),
        aspirante.segundoNombre?.trim(),
        aspirante.apaterno?.trim(),
        aspirante.amaterno?.trim(),
      ]
        .filter(Boolean)
        .join(' ')
    },

    formatDate(date) {
      if (!date) return ''
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(date).toLocaleDateString('es-MX', options)
    },
  },
}
</script>
